/**
 * @auth 赖传峰
 * @date 2022/4/10
 * @desc 针对 /s 路径的中间件，在 [share_id].vue 中使用
 */
import {
  abortNavigation,
  defineNuxtRouteMiddleware,
  navigateTo,
  useNuxtApp,
} from '#imports'
import NProgress from 'nprogress'
import useMessage from '~/composables/useMessage'
import { useShare } from '~/store/share'
import { RouteQueryKey } from '~/types/enum'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const shareId = to.params.share_id as string | undefined
  /* 生成的分享链接后面会带文字说明，如果整段粘贴于浏览器的地址栏中，需要将有效的 share_id 以及密码提取出来 */
  const realShareId = shareId?.replace(/^([-\w]+).*$/, '$1')
  const shareStore = useShare()

  if (shareId && realShareId && shareId !== realShareId) {
    const passcode = shareId?.replace(/^[-\w]+.*?:\s([A-Za-z\d]{4,10}).*$/i, '$1')
    const queryStr = passcode
      ? `?${RouteQueryKey.SHARE_PASSCODE}=${encodeURIComponent(passcode)}`
      : ''
    return navigateTo(`/s/${realShareId}${queryStr}`)
  }

  if (import.meta.server) return

  NProgress.configure({ showSpinner: false })
  NProgress.start()

  if (from.name && shareId) {
    let share: (Share | undefined)
    const passcodeToken = useNuxtApp().$getPasscodeToken(shareId).value

    if (shareId !== from.params.share_id) {
      const {
        data,
        error,
      } = await shareStore.setShare({
        share_id: shareId,
        pass_code: to.query[RouteQueryKey.SHARE_PASSCODE] as string,
        pass_code_token: passcodeToken,
      })
      if (error.value) {
        useMessage({
          type: 'error',
          message: error.value.message,
        })

        NProgress.done()
        return abortNavigation(error.value.message)
      }

      share = data.value
    }

    const parentId = to.params.parent_ids?.slice(-1)[0] as string | undefined
    if (parentId && parentId !== from.params.parent_ids?.slice(-1)[0]) {
      // 点击目录导航，或者点开文件夹
      const { error } = (await (shareStore.setShareDetail({
        share_id: shareId,
        parent_id: parentId,
        pass_code_token: share?.pass_code_token || passcodeToken,
      })))
      if (error) {
        useMessage({
          type: 'error',
          message: error.message,
        })
        NProgress.done()
        return abortNavigation(error.message)
      }
    }

    share && (shareStore.data = share)
  }

  NProgress.done()
})
